import { ExclamationIcon } from "@octopusdeploy/design-system-icons";
import { Tag } from "../../Tag/Tag";
import { MultiSelectOption } from "./MultiSelectOption";
import type { MissingSelectedOption, SharedSelectProps } from "./SelectBase";
import { getSelectedOptionLabel, isMissingSelectedOption, SelectBase } from "./SelectBase";
export interface MultiSelectProps<T> extends SharedSelectProps<T> {
    /**
     * The current values of the select
     */
    value: string[];
    /**
     * The action to perform when the form control field is changed.
     */
    onChange: (newValue: string[]) => void;
    /**
     * A function that returns a MultiSelectOption for an item
     */
    getOption: (item: T) => MultiSelectOption;
}
export function MultiSelect<T>(props: MultiSelectProps<T>) {
    const handleOptionsSelected = (options: MultiSelectedOption[]) => {
        const currentValues = new Set(props.value);
        const toggledValues = new Set(options.map((o) => o.value));
        props.onChange(Array.from(currentValues.symmetricDifference(toggledValues)));
    };
    const canChange = !props.disabled && !props.readOnly;
    const renderOption = (option: MultiSelectOption, selected: boolean) => <MultiSelectOption option={option} selected={selected}/>;
    const renderSelection = (selectedOptions: MultiSelectedOption[]) => {
        if (selectedOptions.length === 1) {
            const selectedOption = selectedOptions[0];
            return <Tag label={getSelectedOptionLabel(selectedOption)} onDismiss={canChange ? () => handleOptionsSelected([selectedOption]) : undefined} prefix={isMissingSelectedOption(selectedOption) ? <ExclamationIcon size={16}/> : undefined}/>;
        }
        return <Tag label={`${selectedOptions.length} selected`}/>;
    };
    return (<SelectBase {...props} isMultiSelectable={true} renderOption={renderOption} onOptionsSelected={handleOptionsSelected} renderSelection={renderSelection} clearSelection={() => {
            props.onChange([]);
        }}/>);
}
type MultiSelectedOption = MultiSelectOption | MissingSelectedOption;
